// import React from "react";
// import "./physiotherapy.css";
// import InquiryForm from "../InquiryForm";
// const PhysiotherapyUSA = () => {
//   return (
//     <div className="physio-container">
//       <h1 className="physio-title">Physiotherapy Career in the USA</h1>

//       <div className="physio-box">
//         <h2>Overview</h2>
//         <p>
//           Physiotherapists in the USA play a vital role in patient rehabilitation,
//           injury management, and promoting mobility. The field is growing rapidly
//           with high demand across hospitals, clinics, and sports organizations.
//         </p>
//       </div>

//       <div className="physio-box">
//         <h2>Eligibility & Requirements</h2>
//         <ul>
//           <li>Doctor of Physical Therapy (DPT) degree is mandatory.</li>
//           <li>Pass the NPTE (National Physical Therapy Examination).</li>
//           <li>State licensure is required.</li>
//         </ul>
//       </div>

//       <div className="physio-box">
//         <h2>Job Prospects</h2>
//         <p>
//           The demand for physiotherapists is projected to grow by 15% in the next decade.
//           Average salary ranges from $80,000 to $110,000 annually depending on specialization.
//         </p>
//       </div>

//       {/* Inquiry Form */}
//         <InquiryForm title="Inquire About USA Programs" />
//     </div>
//   );
// };

// export default PhysiotherapyUSA;


import React from "react";
import "./physiotherapy.css";
import InquiryForm from "../InquiryForm";

const PhysiotherapyUSA = () => {
  return (
    <div className="physio-container">

      {/* Hero */}
      <section className="physio-hero">
        <div className="physio-hero-content">
          <span className="physio-country-badge">🇺🇸 USA</span>
          <h1>Physiotherapy Career in the USA</h1>
          <p>High salaries · Rapid growth · World-class healthcare system</p>
        </div>
      </section>

      {/* Overview */}
      <section className="physio-section">
        <div className="physio-box full-width">
          <div className="box-icon">🌎</div>
          <h2>Overview</h2>
          <p>
            The NPTE, or National Physical Therapy Examination, is a crucial step for
            individuals seeking licensure as a physical therapist or physical therapist
            assistant in the United States. Administered by the Federation of State Boards
            of Physical Therapy (FSBPT), the NPTE is a multiple-choice exam designed to
            evaluate entry-level competence in physical therapy. The PT and PTA exams are
            designed to assess your basic entry-level competence after graduation from an
            accredited program or from an equivalent non-accredited program.
          </p>
        </div>
      </section>

      {/* NPTE Details */}
      <section className="physio-section">
        <div className="physio-box">
          <div className="box-icon">📋</div>
          <h2>NPTE Examination Details</h2>
          <ul className="physio-list">
            <li>
              <strong>Purpose:</strong> Ensures individuals possess the necessary knowledge
              and skills to provide safe and effective patient care.
            </li>
            <li>
              <strong>Content:</strong> Focuses on the clinical application of physical
              therapy knowledge, concepts, and principles.
            </li>
            <li>
              <strong>Administration:</strong> Developed, maintained, and administered by
              the FSBPT.
            </li>
            <li>
              <strong>Eligibility:</strong> Candidates must hold a Bachelor's Degree in
              Physiotherapy at the time of exam.
            </li>
            <li>
              <strong>Exam Type:</strong> Written.
            </li>
          </ul>
        </div>

        <div className="physio-box">
          <div className="box-icon">🏥</div>
          <h2>Career Prospects</h2>
          <p>
            The demand for physiotherapists is projected to grow by <strong>15%</strong> in
            the next decade. Physiotherapists work across hospitals, clinics, sports
            organizations, and private practices across all 50 states.
          </p>
          <ul className="physio-list" style={{ marginTop: '12px' }}>
            <li>Sports physiotherapy</li>
            <li>Neurological rehabilitation</li>
            <li>Paediatric physiotherapy</li>
            <li>Private practice ownership</li>
          </ul>
        </div>
      </section>

      {/* Salary */}
      <section className="physio-section">
        <div className="physio-box salary-card">
          <div className="box-icon">💰</div>
          <h2>Salary in USA</h2>
          <div className="salary-grid">
            <div className="salary-item">
              <span className="salary-label">Starting Salary</span>
              <span className="salary-value">$70,000 – $85,000<small>/year</small></span>
            </div>
            <div className="salary-item">
              <span className="salary-label">Experienced</span>
              <span className="salary-value">$90,000 – $120,000+<small>/year</small></span>
            </div>
            <div className="salary-item">
              <span className="salary-label">Specialized</span>
              <span className="salary-value">Even Higher</span>
            </div>
          </div>
          <p className="salary-inr">
            📌 In INR: approximately <strong>₹60 lakh – ₹1 crore+/year</strong>
          </p>
        </div>
      </section>

      <InquiryForm title="Inquire About USA Programs" />
          <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default PhysiotherapyUSA;